import { useParams } from "react-router-dom";
import { PageHero, CTABand, Rise, Eyebrow, ArrowCard } from "@/components/chrome";
import { findSector, findService, paths } from "@/lib/seo";
import NotFound from "@/pages/NotFound";

export default function SectorPage() {
  const { sectorSlug } = useParams();
  const sector = findSector(sectorSlug);
  if (!sector) return <NotFound />;

  return (
    <div data-testid="sector-page">
      <PageHero prefix="sector"
        crumbs={[{ name: "Home", path: "/" }, { name: "Sectors", path: "/sectors" }, { name: sector.name }]}
        eyebrow="Sector program"
        title={`${sector.name} cleaning services in Canada`}
        lead={sector.desc} />

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-16" data-testid="sector-overview">
        <div className="max-w-3xl space-y-5">
          {sector.body.map((p, i) => <p key={i} className="leading-relaxed text-slate-600 sm:text-lg">{p}</p>)}
        </div>
      </section>

      <section className="border-y border-slate-200 bg-white" data-testid="sector-services">
        <div className="mx-auto max-w-6xl px-5 py-14 sm:py-16">
          <Rise><Eyebrow>Recommended services</Eyebrow>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Core services for {sector.name.toLowerCase()}
            </h2></Rise>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {sector.services.map((slug) => {
              const s = findService(slug);
              return s ? (
                <ArrowCard key={slug} to={paths.service(slug)} icon={s.icon} title={s.name} desc={s.tagline}
                  testid={`sector-service-${slug}`} />
              ) : null;
            })}
          </div>
        </div>
      </section>

      <CTABand title={`Get a ${sector.name.toLowerCase()} cleaning quote`}
        lead="Site walkthroughs and sector-specific programs across Canada — one call starts it."
        prefix="sector-cta" />
    </div>
  );
}
